/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_list__errors__no_category = /** @type {(inputs: {}) => string} */ () => {
	return `Die interessanten Orte (Hotels, Restaurants …) konnten nicht angezeigt werden:\\nSie müssen mindestens eine Kategorie auswählen.`
};

const en_poi_list__errors__no_category = /** @type {(inputs: {}) => string} */ () => {
	return `To display points of interest (hotels, restaurants, etc.), you need to select at least one category.`
};

const es_poi_list__errors__no_category = /** @type {(inputs: {}) => string} */ () => {
	return `Para ver los puntos de interés (hoteles, restaurantes, etc.), debes seleccionar al menos una categoría.`
};

const fr_poi_list__errors__no_category = /** @type {(inputs: {}) => string} */ () => {
	return `Pour afficher des points d'intérêt (hôtels, restaurants...), vous devez sélectionner au moins une catégorie.`
};

const it_poi_list__errors__no_category = /** @type {(inputs: {}) => string} */ () => {
	return `Per visualizzare i punti di interesse (hotel, ristoranti, ecc.) è necessario selezionare almeno una categoria.`
};

const nl_poi_list__errors__no_category = /** @type {(inputs: {}) => string} */ () => {
	return `Om nuttige plaatsen (hotels, restaurants, etc.) weer te geven, moet u minimaal één categorie selecteren.`
};

const pt_poi_list__errors__no_category = /** @type {(inputs: {}) => string} */ () => {
	return `Para visualizar os pontos de interesse (hotéis, restaurantes, etc.), tem de selecionar pelo menos uma categoria.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_category = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_list__errors__no_category(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_list__errors__no_category", locale)
	if (locale === "de") return de_poi_list__errors__no_category(inputs)
	if (locale === "en") return en_poi_list__errors__no_category(inputs)
	if (locale === "es") return es_poi_list__errors__no_category(inputs)
	if (locale === "fr") return fr_poi_list__errors__no_category(inputs)
	if (locale === "it") return it_poi_list__errors__no_category(inputs)
	if (locale === "nl") return nl_poi_list__errors__no_category(inputs)
	return pt_poi_list__errors__no_category(inputs)
};